// @ts-nocheck
import { dialogService } from '../services/dialog.service';
/**
 * Error Wrapper
 */
export function axiosErrorWrapper(error, autoHandleError = () => true) {
  console.error('errorWrapper', error);
  let errorData = {
    code: 'HttpService/WrongSetting',
    message: 'Error happened!',
  };
  let status = error.response ? error.response.status : 'common';

  if (error.response) {
    console.error('error.response', error.response);
    errorData = { ...error.response.data, status };
  } else if (error.request) {
    console.error('error.request', error.request);
    errorData = {
      code: 'HttpService/NoResponse',
      message: 'The request was made but no response was received.',
    };
  } else if (error.message === 'No internet connection') {
    status = 'NO_INTERNET';
    errorData = {
      code: 'HttpService/NoInternet',
      message: error.message,
    };
  } else {
    console.error('Error', error.message);
    errorData = {
      code: 'HttpService/postWithoutAuth/WrongSetting',
      message:
        'Something happened in setting up the request that triggered an Error.',
    };
  }

  if (autoHandleError(errorData)) {
    dialogService.httpError({
      status,
      error: errorData,
      request: error.config,
      response: error.response,
    });
  }

  console.error('error.config', error.config);
  return errorData;
}
